import { render, staticRenderFns } from "./FormDetailFields.vue?vue&type=template&id=2163bc84&scoped=true&"
import script from "./FormDetailFields.vue?vue&type=script&lang=js&"
export * from "./FormDetailFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2163bc84",
  null
  
)

export default component.exports